<template>
  <div class="list-group">
    <template v-for="key in Object.keys(tree).sort()" :key="key">
      <template v-if="key === '__files'">
        <div>
          <div v-for="file in tree[key]" :key="file.id"
               class="list-group-item d-flex justify-content-between align-items-center flex-wrap">
            <div class="col-12 col-sm-6 col-md-5 text-break">
              <i class="bi bi-file-earmark me-1"></i>{{ file.name }}
            </div>
            <div class="col-12 col-sm-4 col-md-4 text-muted small">
              <i>{{ formatDate(file.created_at) }}</i>
            </div>
            <div class="col-12 col-sm-2 col-md-3 text-end mt-2 mt-sm-0">
              <div class="d-inline-flex">
                <a class="btn btn-sm btn-outline-info me-2"
                   :href="route('services.download-services-file', { id: service.id, fileName: file.name, ...(file.folders && file.folders !== '.' ? { folder: file.folders } : {})})"
                   download>
                  <i class="bi bi-download me-1"></i>Pobierz
                </a>
                <button v-if="hasPermission('canEditService')" class="btn btn-sm btn-outline-danger"
                        @click="$emit('deleteFile', file)">
                  <i class="bi bi-trash me-1"></i>Usuń
                </button>
              </div>
            </div>
          </div>
        </div>
      </template>

      <template v-else>
        <div class="list-group-item bg-light fw-bold d-flex justify-content-between align-items-center">
          <div>
            <i class="bi bi-folder-fill me-1"></i>{{ key }}
          </div>
          <div v-if="hasPermission('canEditService')">
            <button class="btn btn-sm btn-outline-success" @click="triggerFileInput(key)"
                    aria-label="Dodaj plik do folderu" title="Dodaj plik do folderu">
              <i class="bi bi-plus-circle"></i>
            </button>
            <input type="file" :ref="`fileInput_${key}`" style="display:none" @change="handleFileSelect($event, key)">
          </div>
        </div>
        <div class="ps-4">
          <TreeView :tree="tree[key]" :service="service" :folderPath="folderPath ? folderPath + '/' + key : key"
                    @deleteFile="$emit('deleteFile', $event)"
                    @uploadFileToFolder="$emit('uploadFileToFolder', $event)"/>
        </div>
      </template>
    </template>
  </div>
</template>

<script>
import {usePermission} from "@/composables/resources/js/composables/permissions.js";
import route from "../../../../vendor/tightenco/ziggy/src/js/index.js";

const {hasPermission} = usePermission();

export default {
  name: "TreeView",
  props: {
    tree: {type: Object, required: true, default: () => ({})},
    service: {type: Object, required: true, default: () => ({})},
    folderPath: {type: String, default: ''},
  },
  methods: {
    hasPermission,
    route,
    formatDate(dateStr) {
      const date = new Date(dateStr);
      return new Intl.DateTimeFormat('pl-PL', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hour12: false,
        timeZone: 'Europe/Warsaw'
      }).format(date);
    },
    triggerFileInput(folderName) {
      this.$refs[`fileInput_${folderName}`][0].click();
    },
    handleFileSelect(event, folderName) {
      const files = Array.from(event.target.files);
      if (files.length === 0) return;
      const fullFolderPath = this.folderPath ? this.folderPath + '/' + folderName : folderName;
      this.$emit('uploadFileToFolder', {file: files[0], folderName: fullFolderPath});
      event.target.value = null;
    }
  },
};
</script>
